<template>
    <div class="main-page">
      <template v-if="showHeader">
        <section class="page-section">
          <div class="container">
            <div class="grid justify-content-between">
              <div class="col">
                <div class="">
                  <div class="text-3xl font-bold">Reset User Password</div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <hr />
      </template>
      <section class="page-section pt-2">
        <div class="container">
          <div class="grid">
            <div class="md:col-9 sm:col-12 comp-grid">
              <div class="">
                <div class="">
                  <div>
                    <template v-if="pageReady">
                      <div class="grid">
                        <div class="col-12">
                          <form
                            ref="observer"
                            tag="form"
                            @submit.prevent="submitForm()"
                            class=""
                            :class="{ card: !isSubPage }"
                          >
                          <div class="text-lg text-caption text-grey">A new Password will be generated and sent to user's email - {{ formData.email }} </div>
                            <div v-if="showSubmitButton" class="text-center my-3">
                              <Button
                                type="submit"
                                label="Send New Password"
                                class="p-button-rounded"
                                icon="pi pi-send"
                                :loading="saving"
                              />
                            </div>
                          </form>
                        </div>
                      </div>
                    </template>
                    <template v-if="loading">
                      <div class="p-3 text-center">
                        <ProgressSpinner style="width: 50px; height: 50px" />
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </template>
  <script setup>
  import { computed, reactive, toRefs, onMounted } from "vue";
  import useVuelidate from "@vuelidate/core";
  import { required } from "@/services/validators";
  import { useApp } from "@/composables/app.js";
  import { useEditPage } from "@/composables/editpage.js";
  const props = defineProps({
    id: [String, Number],
    pageName: {
      type: String,
      default: "users",
    },
    routeName: {
      type: String,
      default: "usersreset",
    },
    pagePath: {
      type: String,
      default: "users/reset",
    },
    apiPath: {
      type: String,
      default: "users/reset",
    },
    submitButtonLabel: {
      type: String,
      default: "Send New Password",
    },
    formValidationError: {
      type: String,
      default: "Form is invalid",
    },
    formValidationMsg: {
      type: String,
      default: "Please complete the form",
    },
    msgAfterUpdate: {
      type: String,
      default: "User password reset successful",
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    showSubmitButton: {
      type: Boolean,
      default: true,
    },
    redirect: {
      type: Boolean,
      default: true,
    },
    isSubPage: {
      type: Boolean,
      default: false,
    },
  });
  const app = useApp();
  const formDefaultValues = Object.assign(
    { },
    props.pageData
  );
  const formData = reactive({ ...formDefaultValues });
  function onFormSubmited(response) {
    app.flashMsg(props.msgAfterUpdate);
    if (props.redirect) app.navigateTo(`/users`);
  }
  const rules = computed(() => {
    return { };
  });
  const v$ = useVuelidate(rules, formData); //form validation
  const page = useEditPage(props, formData, v$, onFormSubmited);
  //page state
  const {
    submitted, // form api submitted state - Boolean
    saving, // form api submiting state - Boolean
    loading, // form data loading state - Boolean
    pageReady, // if api data loaded successfully
  } = toRefs(page.state);
  //page computed propties
  const {
    apiUrl, // page current api path
    currentRecord, // current page record  - Object
  } = page.computedProps;
  //page methods
  const {
    load, // get editable form data from api
    submitForm, // submit form data to api
    getErrorClass, // return error class if field is invalid- args(fieldname)
    getFieldError, //  get validation error message - args(fieldname)
    isFieldValid, // check if field is validated - args(fieldname)
    // map api datasource  to Select options label-value
  } = page.methods;
  onMounted(() => {
    const pageTitle = "Reset User Account";
    app.setPageTitle(props.routeName, pageTitle); // set browser page title
    load();
  });
  </script>
  <style scoped></style>
  